import { render, staticRenderFns } from "./OrderPartsRemark.vue?vue&type=template&id=2fd24ab0&scoped=true"
import script from "./OrderPartsRemark.vue?vue&type=script&lang=js"
export * from "./OrderPartsRemark.vue?vue&type=script&lang=js"
import style0 from "./OrderPartsRemark.vue?vue&type=style&index=0&id=2fd24ab0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd24ab0",
  null
  
)

export default component.exports